<template>
  <div class="wrapper">
    <div class="block">
      <p-vue-table
        :value="DisplayTransactionTable"
        dataKey="id"
        responsiveLayout="scroll"
      >
        <p-vue-column field="TransactionTypeName" :header="__('Type')">
        </p-vue-column>
        <p-vue-column field="OriginalSum" :header="__('For a fee')">
          <template #body="{ data }">
            {{ __u_value__({ value: data.OriginalSum, unit: "P-NIS" }) }}
          </template>
        </p-vue-column>

        <p-vue-column field="totalAmount" v-if="showTotalAmount">
          <template #header>
            <span>{{ __("Including credit fees") }}</span>
          </template>
          <template #body="{ data }">
            <span v-if="data.OriginalSum !== data.totalAmount">{{
              __u_value__({
                value: data.totalAmount,
                unit: "P-NIS",
              })
            }}</span>
          </template>
        </p-vue-column>
        <p-vue-column field="numberOfPayments" :header="__('Payments')">
          <template #body="{ data }">
            <i-override-dropdown
              :options="
                Array.from(
                  { length: data.MaxPaymentsAllowed },
                  (_, index) => index + 1
                )
              "
              v-model="data.numberOfPayments"
              @change="
                ccTranzUpdateNumberOfPayments(
                  data.ccTranID,
                  data.numberOfPayments
                )
              "
              class="p-dropdown-rounded p-dropdown-success"
            >
            </i-override-dropdown>
          </template>
        </p-vue-column>
      </p-vue-table>
    </div>
    <div
      class="block"
      style="text-align: center;"
      v-if="DisplayTransactionTotal[0]?.CommissionSum != 0"
    >
      <div>
        {{
          __(
            "The amount of the full credit fee that will be charged based on these transactions is:"
          )
        }}
        {{
          __u_value__({
            value: DisplayTransactionTotal[0]?.CommissionSum,
            unit: "number-f",
          })
        }}
        ({{
          __u_value__({
            value: DisplayTransactionTotal[0]?.ComRate * 100,
            unit: "number-f",
          })
        }}%)
      </div>
      <div v-if="DisplayTransactionTotal[0]?.CommissionAction && DisplayTransactionTotal[0]?.CommissionAction != 0">
        {{
          __(
            "The transaction fee amount that will be charged based on these transactions is:"
          )
        }}
        {{
          __u_value__({
            value: DisplayTransactionTotal[0]?.CommissionAction,
            unit: "number-f",
          })
        }}
      </div>
      <br />

      <div>
        {{
          __(
            "If the credit card was issued outside Israel, the commission will be 3% + VAT of the total transaction"
          )
        }}
      </div>
    </div>
    <div class="block  p-p-1" style="text-align: center;">
      {{ __("It is not possible to pay with an American Express credit card") }}
    </div>

    <hok-radio
      v-if="createHokPanel"
      @updateData="updateData"
      @saveHokChange="handleHokChange"
      @hokDateChange="handleHokDateChange"
    />
  </div>
</template>

<script>
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { errorReceived } from "@/services/apointUtil";
// import { mapState } from "vuex";
import HokRadio from "./hok-radio.vue";
import { mapState } from "vuex";
export default {
  emits: [
    "getBatchData",
    "saveHokChange",
    "hokDateChange",
    "ErrCreateTransactionTable",
  ],
  props: ["createHokPanel", "contactId"],
  data() {
    return {
      BatchID: 0,
      BatchDescription: "",
      DisplayTransactionTotal: [],
      DisplayTransactionTable: [],
      hokDate: "1",
      saveHok: null,
      limitToDate: new Date(),
      minDate: new Date(),
      showTotalAmount: false,
    };
  },
  components: { HokRadio },
  mounted() {
    this.appCreateTransactionTable();
    // console.log(this.contactId);
  },
  methods: {
    updateData(key, value) {
      this.$emit("updateData", key, value);
    },
    ccTranzUpdateNumberOfPayments(ccTranID, NumberOfPayments) {
      let procParams = [
        apiParam("ccTranID", ccTranID, apiPType.Int),
        apiParam("NumberOfPayments", NumberOfPayments, apiPType.Int),
      ];
      callProc("ccTranzUpdateNumberOfPayments", procParams)
        .then((result) => {
          console.log(result);
        })
        .catch((error) => {
          errorReceived(error);
        });
    },
    appCreateTransactionTable() {
      let procParams = [
        apiParam("ContactID", this.contactId, apiPType.Int),
        apiParam("UserID", this.userNum, apiPType.Int),
      ];
      callProc("appCreateTransactionTable_V2", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log(result);
          this.BatchID = +result.Table[0].DataID;
          this.BatchDescription = result.Table[0].DataDescription;
          if (this.BatchID < 0) {
            errorReceived(
              "Payment can not be continued",
              null,
              this.BatchDescription
            );
            this.$emit("ErrCreateTransactionTable");
          } else {
            this.appDisplayTransactionTotal();
          }
        })
        .catch((error) => {
          errorReceived(error);
        });
    },
    appDisplayTransactionTotal() {
      let procParams = [apiParam("BatchID", this.BatchID, apiPType.Int)];
      callProc("appDisplayTransactionTotal", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.DisplayTransactionTotal = result.Table;
          this.appDisplayTransactionTable();
        })
        .catch((error) => {
          errorReceived(error);
        });
    },
    appDisplayTransactionTable() {
      let procParams = [apiParam("BatchID", this.BatchID, apiPType.Int)];
      callProc("appDisplayTransactionTable", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.DisplayTransactionTable = result.Table;
          this.showTotalAmount =
            this.DisplayTransactionTable.filter(
              (f) => f.OriginalSum !== f.totalAmount
            ).length > 0;

          this.$emit(
            "getBatchData",
            this.BatchID,
            this.DisplayTransactionTable.length
          );
        })
        .catch((error) => {
          errorReceived(error);
        });
    },
    handleHokChange(saveHok) {
      this.$emit("saveHokChange", saveHok);
    },
    handleHokDateChange({ hokDate, limitToDate }) {
      this.$emit("hokDateChange", { hokDate, limitToDate });
    },
  },
  computed: {
    ...mapState({
      userNum: (state) => state.api.workerID,
      // contactId: (state) => state.api.contactID,
    }),
  },
  watch: {
    // saveHok:{
    //   immediate:true,
    //   handler(){
    // this.handleHokChange(this.saveHok)
    // this.$emit("saveHokChange", this.saveHok);
    // if(this.saveHok){
    //   const oneMonthFromNow = new Date().getMonth()+1
    //   this.limitToDate.setMonth(oneMonthFromNow)
    //   this.minDate.setMonth(oneMonthFromNow)
    // }
    //   },
    // },
    // hokDate:{
    //   immediate:true,
    //   handler(){
    //     this.handleHokDateChange()
    //     const { hokDate, limitToDate } = this;
    //     this.$emit("hokDateChange", { hokDate, limitToDate });
    //   }
    // },
  },
};
</script>

<style scoped>
.wrapper {
  padding: 5px;
}

.block {
  margin-bottom: 5px;

  background-color: var(--color-bg);
}

.block__heading {
  margin: 0;
  padding: 15px;

  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0.58px;
  color: var(--color-primary);
}

.block:deep(.p-datatable .p-datatable-thead > tr > th) {
  padding: 10px;
}

.block:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 10px;

  border: none;
  background-color: var(--color-bg);
}

.block:deep(.p-dropdown .p-dropdown-label) {
  padding-top: 3px;
  padding-bottom: 3px;
}

:deep(.p-override-dropdown .icons .svg) {
  width: 11px;
  height: 10px;
}

.points {
  padding: 0 25px;
}
.points > i {
  margin-bottom: 10px;
  margin-left: 5px;
}

.points:deep(.pi-check) {
  color: var(--color-success);
}
</style>
